import { cva } from 'class-variance-authority';

export const cvaPortalOverlay = cva([
  'PortalStyles-cvaPortalOverlay',
  'fixed top-0 bg-cBlack min-h-full w-full z-[100]',
]);
